import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, MessageCircle } from "lucide-react";
import { BRAND } from "@/data/policies";

export default function Footer() {
  return (
    <footer className="border-t border-black/10 mt-24 bg-white grain">
      {/* Trust badges strip */}
      <div className="border-b border-black/10 py-8">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          <TrustBadge title="SHIPS WITHIN 48 HRS" subtitle="From order confirmation" />
          <TrustBadge title="FREE SHIPPING ₹1499+" subtitle="Across India" />
          <TrustBadge title="EASY RETURNS" subtitle="15 days from delivery" />
          <TrustBadge title="MADE IN INDIA" subtitle="Designed in Pune" />
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-3 mb-6">
            <img src="/logo-be-512.png" alt="" className="h-12 w-12 object-contain" />
            <span className="font-display text-2xl tracking-tighter text-black leading-none">BYONDELMNTS</span>
          </div>
          <h2 className="font-display text-5xl tracking-tighter leading-none text-black">
            BUILT<br />FOR THE<br />STREETS.
          </h2>
          <p className="mt-6 text-black/60 max-w-md">
            BYONDELMNTS is a streetwear house designing limited drops for those
            who refuse to blend in. Heavyweight cuts. Garment-dyed. Made in India.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="#" aria-label="Instagram" className="w-10 h-10 border border-black/30 flex items-center justify-center hover-invert text-black"><Instagram size={16}/></a>
            <a href="#" aria-label="Twitter" className="w-10 h-10 border border-black/30 flex items-center justify-center hover-invert text-black"><Twitter size={16}/></a>
            <a href="#" aria-label="YouTube" className="w-10 h-10 border border-black/30 flex items-center justify-center hover-invert text-black"><Youtube size={16}/></a>
            <a href={BRAND.whatsappLink} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="w-10 h-10 border border-black/30 flex items-center justify-center hover-invert text-black"><MessageCircle size={16}/></a>
          </div>
        </div>

        <div>
          <div className="font-display text-xs tracking-widest text-black/40 mb-4">SHOP</div>
          <ul className="space-y-3 text-sm text-black/80">
            <li><Link to="/shop/men" className="hover:text-[#FF3B30]">Men</Link></li>
            <li><Link to="/shop/women" className="hover:text-[#FF3B30]">Women</Link></li>
            <li><Link to="/drops" className="hover:text-[#FF3B30]">New Drops</Link></li>
            <li><Link to="/shop/collabs" className="hover:text-[#FF3B30]">Collabs</Link></li>
            <li><Link to="/shop/sale" className="hover:text-[#FF3B30]">Sale</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-display text-xs tracking-widest text-black/40 mb-4">SUPPORT</div>
          <ul className="space-y-3 text-sm text-black/80">
            <li><Link to="/contact" className="hover:text-[#FF3B30]" data-testid="footer-contact">Contact Us</Link></li>
            <li><Link to="/faqs" className="hover:text-[#FF3B30]" data-testid="footer-faqs">FAQs</Link></li>
            <li><Link to="/size-guide" className="hover:text-[#FF3B30]" data-testid="footer-size-guide">Size Guide</Link></li>
            <li><Link to="/orders" className="hover:text-[#FF3B30]">Track Order</Link></li>
            <li><Link to="/account" className="hover:text-[#FF3B30]">My Account</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-display text-xs tracking-widest text-black/40 mb-4">POLICIES</div>
          <ul className="space-y-3 text-sm text-black/80">
            <li><Link to="/policies/shipping" className="hover:text-[#FF3B30]" data-testid="footer-shipping">Shipping Policy</Link></li>
            <li><Link to="/policies/returns" className="hover:text-[#FF3B30]" data-testid="footer-returns">Returns & Exchange</Link></li>
            <li><Link to="/policies/privacy" className="hover:text-[#FF3B30]">Privacy Policy</Link></li>
            <li><Link to="/policies/terms" className="hover:text-[#FF3B30]">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>

      {/* Contact strip */}
      <div className="border-t border-black/10 bg-black/[0.02]">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-6 grid md:grid-cols-3 gap-3 text-xs font-mono text-black/70">
          <span>📧 <a href={`mailto:${BRAND.email}`} className="hover:text-[#FF3B30]">{BRAND.email}</a></span>
          <span>📞 <a href={`tel:${BRAND.phoneTel}`} className="hover:text-[#FF3B30]">{BRAND.phoneDisplay}</a></span>
          <span>🕘 {BRAND.hours}</span>
        </div>
      </div>

      <div className="border-t border-black/10">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-black/40 font-mono">
          <span>© 2026 BYONDELMNTS EXIM LLP — ALL RIGHTS RESERVED</span>
          <span>MADE IN INDIA · SHIPPED WORLDWIDE</span>
        </div>
      </div>
    </footer>
  );
}

function TrustBadge({ title, subtitle }) {
  return (
    <div>
      <div className="font-display tracking-widest text-xs text-black">{title}</div>
      <div className="text-xs font-mono text-black/50 mt-1">{subtitle}</div>
    </div>
  );
}
